export const global = {
  namespaced: true,
  state: {
    loading: false,
    errorStatus: false,
    errorMessage: '',
    errorType: 1,
    name: '-',
    dob: null,
    icons: [],
  },
  getters: {
  },
  mutations: {
    SET_ERROR_STATUS(state, payload) {
      state.errorStatus = payload;
    },
    SET_ERROR_MESSAGE(state, payload) {
      state.errorMessage = payload;
    },
    SET_ERROR_TYPE(state, payload) {
      state.errorType = payload;
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_NAME(state, payload) {
      state.name = payload;
    },
    SET_DOB(state, payload) {
      state.dob = payload;
    },
  },
  actions: {
    setError({ commit }, payload) {
      const { status, err = 'Error', type = 1 } = payload;
      // console.log(err.response)
      commit('SET_ERROR_STATUS', status);
      commit('SET_ERROR_MESSAGE', `${err.response?.data?.detail}`);
      // commit('SET_ERROR_MESSAGE', `${err?.message} - ${err.response.data.message}`)
      commit('SET_ERROR_TYPE', type);
      commit('SET_LOADING', false);
    },
    resetError(context) {
      context.commit('SET_ERROR_STATUS', false);
      context.commit('SET_ERROR_MESSAGE', '');
      context.commit('SET_ERROR_TYPE', 2);
    },
    setLoading({ commit }, val) {
      commit('SET_LOADING', val);
    },
    setName({ commit }, val) {
      commit('SET_NAME', val);
    },
    setDob({ commit }, val) {
      commit('SET_DOB', val);
    },
  },
};
